import { render, staticRenderFns } from "./scaling.vue?vue&type=template&id=1f32b3f4&scoped=true"
import script from "./scaling.vue?vue&type=script&lang=js"
export * from "./scaling.vue?vue&type=script&lang=js"
import style0 from "./scaling.vue?vue&type=style&index=0&id=1f32b3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32b3f4",
  null
  
)

export default component.exports